var exports = {
  "k": "xfb577c5e--b376f4--container",
  "p": "xfb577c5e--b376f4--price-info",
};

module.exports = exports;
